import React, { Fragment } from "react";
import "../../templateform/templateform.css";
import Accordion from "react-bootstrap/Accordion";
import { Form } from "react-router-dom";


function IncrementSection(props) {
    const { data, setData, languageData } = props;

    const addNewEntery = () => {
        let newOdj = {
            description: "",
            counter_number: "",
            status: false,
        };
        let newArr = { ...data }
        let arrItem = [...newArr.items, newOdj]
        newArr['items'] = arrItem
        setData(newArr);
    };

    const removeEntery = (index) => {
        let newArr = { ...data };
        let arrItem = newArr.items;
        if (arrItem.length > 1) {
            arrItem.splice(index, 1);
        }
        newArr['items'] = arrItem
        setData(newArr);
    };

    const handleInputValue = (index, name, value) => {
        let newArr = { ...data };
        let arr = [...newArr.items]
        arr[index][name] = value
        setData({ ...data, items: arr })
    }
    const handleToggle = (e) => {
        e.stopPropagation(); // Prevent the Accordion from toggling
        setData({
            ...data,
            status: !data?.status
        });
    };
    return (
        <Fragment>
            <Accordion.Header>
                <div className="drop_header_dflex">
                    <div>
                        <img src="/assets/images/icon/profit.png" alt="Add Increment" width={'13%'} /> {" "}
                        {languageData?.addIncrement}
                    </div>
                    <Form.Check
                        defaultChecked={data?.status}
                        style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
                        type="switch"
                        className="custom-switch"
                        onChange={handleToggle}
                        onClick={(e) => e.stopPropagation()} // Prevent event bubbling
                    />
                </div>
            </Accordion.Header>
            {data &&
                <Accordion.Body>
                    {data.items.length > 0 && data.items.map((item, index) => (
                        <div key={index}>
                            <div className="row new_fild_shadow">
                                {index > 0 && (
                                    <div className="sav-proj-btn">
                                        <label className="thm_switch__btn card_input_swich_btn">
                                            <input className="thm_switch_input" type="checkbox" onChange={(e) => handleInputValue(index, 'status', item.status === true ? false : true)} checked={item.status} />
                                            <span className="thm_switch_slider round"></span>
                                        </label>
                                        <button
                                            className="cancel-btn"
                                            onClick={() => removeEntery(index)}
                                            type="button"
                                        >
                                            <i
                                                className="fa fa-times"
                                                aria-hidden="true"
                                            ></i>
                                        </button>
                                    </div>
                                )}
                                <div className="col-lg-6">
                                    <div className="input-field-box">
                                        <label className="forn_title">{languageData?.counterNumber}:</label>
                                        <input
                                            placeholder="Ex. 125"
                                            className="form-control"
                                            value={item.counter_number}
                                            onChange={(e) => handleInputValue(index, 'counter_number', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="input-field-box">
                                        <label className="forn_title">{languageData?.description}:</label>
                                        <textarea
                                            placeholder="Description ..."
                                            className="form-control pb-5"
                                            value={item.description}
                                            onChange={(e) => handleInputValue(index, 'description', e.target.value)}
                                        />
                                    </div>
                                </div>

                            </div>
                            {index === data.items.length - 1 && (
                                <div className="sav-proj-btn">
                                    <button
                                        className="sub-btn"
                                        onClick={addNewEntery}
                                        type="button"
                                    >
                                        {languageData?.addMore}
                                    </button>
                                </div>
                            )}
                        </div>
                    ))}
                </Accordion.Body>
            }
        </Fragment>
    );
}
export default IncrementSection;
